// We want to redirect the user somewhere in the app, respecting locale (by using navigate(to) which handles this)
// but only if they are not already in that route.

import React, {useEffect} from "react";
import PropTypes from "prop-types";
import {useLocation} from "../../../common/common";

export const LocalizedRedirect = ({to}) => {
    const {navigate, isRouteInLocation} = useLocation();

    useEffect(() => {
        // The route "/" will always be inside location. Therefore if we are located anywhere and want to go to "/",
        // we must handle it specifically
        // Prefer to use the literal "/" here than a constant HOME as the constant content may change, but the specificity here is targeted to "/"
        // and not what HOME may at any time
        if ((to && !isRouteInLocation(to)) || to === "/") {
            navigate(to);
        }
    }, [to]);

    return (<div />);
};


LocalizedRedirect.propTypes = {
    to: PropTypes.string.isRequired
};


export default LocalizedRedirect;